var $3y2hQ$uuid = require("uuid");


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

$parcel$export(module.exports, "renderFields", () => $f6142358ef0cb385$export$1b4461fdcf0903a6);


const $5bebb6f528a969bd$export$7d576a40358207c0 = [
    "cvv",
    "expirationDate",
    "cardNumber"
];
var $5bebb6f528a969bd$export$bdb47a4f704771fb = /*#__PURE__*/ function(GlobalPostMessageEventKind) {
    GlobalPostMessageEventKind["PAYMENT_CARD_FETCH_ERROR"] = "PAYMENT_CARD_FETCH_ERROR";
    GlobalPostMessageEventKind["PAYMENT_CARD_FETCH_SUCCESS"] = "PAYMENT_CARD_FETCH_SUCCESS";
    // Input/configuration error kind
    GlobalPostMessageEventKind["CARD_VIEWER_INPUT_ERROR"] = "CARD_VIEWER_INPUT_ERROR";
    GlobalPostMessageEventKind["INVALID_CREDENTIAL_ERROR"] = "INVALID_CREDENTIAL_ERROR";
    GlobalPostMessageEventKind["GENERIC_ERROR"] = "GENERIC_ERROR";
    GlobalPostMessageEventKind["TOGGLE_CARD_NUMBER_MASK"] = "TOGGLE_CARD_NUMBER_MASK";
    GlobalPostMessageEventKind["COPY_TO_CLIPBOARD_ERROR"] = "COPY_TO_CLIPBOARD_ERROR";
    GlobalPostMessageEventKind["COPY_TO_CLIPBOARD_SUCCESS"] = "COPY_TO_CLIPBOARD_SUCCESS";
    GlobalPostMessageEventKind["CARD_VIEWER_READY"] = "CARD_VIEWER_READY";
    return GlobalPostMessageEventKind;
}({});


// -- Secure channel handshake protocol (DX-8174 / DX-8205) -------------------
// Shared by every Highnote SDK that delivers credentials to a hosted iframe
// without placing them in the iframe URL (browser history/sync, web archives,
// CDN/proxy logs, analytics scripts reading location.href). The SDK posts
// HANDSHAKE_INIT to the iframe on frame `load` (transferring one MessagePort),
// the iframe replies HANDSHAKE_ACK on that port, and the SDK then delivers
// credentials in a CONFIGURE message over the same private port.
//
// This module lives in @highnoteplatform/types — not @highnoteplatform/iframes —
// deliberately: the published SDKs' parcel builds bundle ONLY this package
// (targets.*.includeNodeModules allowlist, built with --no-scope-hoist, i.e. no
// tree-shaking), so importing the iframes package here would drag its entire
// re-export graph into the public SDK bundles. Do not "tidy" this into iframes.
const $88ddf2e75f4a6fe1$export$bdf67dc867af0994 = "SECURE_CHANNEL_HANDSHAKE_INIT";
const $88ddf2e75f4a6fe1$export$21b7abb723f51b7e = "SECURE_CHANNEL_HANDSHAKE_ACK";
const $88ddf2e75f4a6fe1$export$46fb7dfe3495e1c = "SECURE_CHANNEL_CONFIGURE";
const $88ddf2e75f4a6fe1$export$9941bb4ec5193584 = 10000;
const $88ddf2e75f4a6fe1$export$ca4bc7545e4f4a8d = 15000;
const $88ddf2e75f4a6fe1$export$b5130285aa45b350 = (data, typename)=>typeof data === "object" && data !== null && "__typename" in data && data.__typename === typename;
const $88ddf2e75f4a6fe1$export$84683bda827d284f = ({ frame: frame, iframeOrigin: iframeOrigin, uuid: uuid, clientToken: clientToken, paymentCardId: paymentCardId, sdkName: sdkName, sdkVersion: sdkVersion, onFailure: onFailure, onHandshakeAck: onHandshakeAck, timeoutMs: timeoutMs = $88ddf2e75f4a6fe1$export$9941bb4ec5193584 })=>{
    let disposed = false;
    let failed = false;
    let cleanupPending;
    // onFailure is one-shot for the channel's lifetime. A frame can emit `load`
    // more than once (reload), and both the FRAME_UNREACHABLE and
    // HANDSHAKE_TIMEOUT paths can be reached again on a subsequent load — the
    // integrator must not be re-notified of the same failed handshake, nor
    // receive a failure after an earlier one already fired.
    const reportFailure = (failure)=>{
        if (failed) return;
        failed = true;
        onFailure(failure);
    };
    const onLoad = ()=>{
        // A reloaded frame is a fresh document with a fresh listener; tear down
        // the previous channel so its timeout cannot fire a spurious error.
        cleanupPending?.();
        cleanupPending = undefined;
        const targetWindow = frame.contentWindow;
        if (targetWindow === null) {
            reportFailure("FRAME_UNREACHABLE");
            return;
        }
        const channel = new MessageChannel();
        const sdkPort = channel.port1;
        const timeout = setTimeout(()=>{
            sdkPort.close();
            cleanupPending = undefined;
            reportFailure("HANDSHAKE_TIMEOUT");
        }, timeoutMs);
        cleanupPending = ()=>{
            clearTimeout(timeout);
            sdkPort.close();
        };
        sdkPort.onmessage = (event)=>{
            if (!$88ddf2e75f4a6fe1$export$b5130285aa45b350(event.data, $88ddf2e75f4a6fe1$export$21b7abb723f51b7e)) return;
            clearTimeout(timeout);
            onHandshakeAck?.();
            const configure = {
                __typename: $88ddf2e75f4a6fe1$export$46fb7dfe3495e1c,
                clientToken: clientToken,
                ...paymentCardId === undefined ? {} : {
                    paymentCardId: paymentCardId
                },
                ...sdkName === undefined ? {} : {
                    sdkName: sdkName
                },
                ...sdkVersion === undefined ? {} : {
                    sdkVersion: sdkVersion
                }
            };
            sdkPort.postMessage(configure);
            // CONFIGURE is the last message on this channel; the iframe closes its
            // end on receipt. Close ours too for lifecycle symmetry — the message
            // is already queued on the peer, so closing here does not drop it.
            // (cleanupPending is left as-is; the disposer's close() is idempotent.)
            sdkPort.close();
        };
        const init = {
            __typename: $88ddf2e75f4a6fe1$export$bdf67dc867af0994,
            uuid: uuid
        };
        targetWindow.postMessage(init, iframeOrigin, [
            channel.port2
        ]);
    };
    frame.addEventListener("load", onLoad);
    return ()=>{
        if (disposed) return;
        disposed = true;
        frame.removeEventListener("load", onLoad);
        cleanupPending?.();
        cleanupPending = undefined;
    };
};
const $88ddf2e75f4a6fe1$export$d572882ed38b887b = ()=>{
    let settled = false; // one handshake-phase error already surfaced
    let configurePhase = false; // ACK received -> iframe is sole authority
    return {
        ack: ()=>{
            configurePhase = true;
        },
        wrapFailure: (deliver)=>(e)=>{
                if (settled) return;
                settled = true;
                deliver(e);
            },
        wrapRelay: (deliver)=>(e)=>{
                if (configurePhase) {
                    deliver(e); // post-ACK: pass every relayed error unconditionally
                    return;
                }
                if (settled) return; // pre-ACK duplicate: swallow
                settled = true;
                deliver(e);
            }
    };
};


const $208e84638651e912$export$1ec34c2c9b231c0f = [
    "pin",
    "cardNumber",
    "expirationMonth",
    "expirationYear",
    "expirationDate",
    "securityCode"
];
const $208e84638651e912$export$2db53370b14e73a1 = [
    "visa",
    "mastercard",
    "amex",
    "discover"
];
var $208e84638651e912$export$5278e3e6401288b4 = /*#__PURE__*/ function(SecureInputsGlobalPostMessageEventKind) {
    SecureInputsGlobalPostMessageEventKind["GENERIC_ERROR"] = "GENERIC_ERROR";
    SecureInputsGlobalPostMessageEventKind["INVALID_CREDENTIAL_ERROR"] = "INVALID_CREDENTIAL_ERROR";
    SecureInputsGlobalPostMessageEventKind["USER_INPUT_ERROR"] = "USER_INPUT_ERROR";
    SecureInputsGlobalPostMessageEventKind["REQUEST_ERROR"] = "REQUEST_ERROR";
    SecureInputsGlobalPostMessageEventKind["ON_INPUT"] = "ON_INPUT";
    SecureInputsGlobalPostMessageEventKind["ON_SUBMIT"] = "ON_SUBMIT";
    SecureInputsGlobalPostMessageEventKind["CHANGE_CARD_PIN"] = "CHANGE_CARD_PIN";
    SecureInputsGlobalPostMessageEventKind["TOKENIZE_CARD"] = "TOKENIZE_CARD";
    SecureInputsGlobalPostMessageEventKind["ON_CARD_INPUT"] = "ON_CARD_INPUT";
    SecureInputsGlobalPostMessageEventKind["ON_PIN_CHANGE_SUCCESS"] = "ON_PIN_CHANGE_SUCCESS";
    SecureInputsGlobalPostMessageEventKind["ON_TOKENIZE_CARD_SUCCESS"] = "ON_TOKENIZE_CARD_SUCCESS";
    SecureInputsGlobalPostMessageEventKind["ON_STATE_CHANGE"] = "ON_STATE_CHANGE";
    SecureInputsGlobalPostMessageEventKind["ON_READY"] = "ON_READY";
    return SecureInputsGlobalPostMessageEventKind;
}({});






var $9b7c8203005ff18b$export$c278f139ce6eedba = /*#__PURE__*/ function(CheckoutPostMessageKind) {
    CheckoutPostMessageKind["TOKENIZE_SUCCCESS"] = "TOKENIZE_SUCCCESS";
    CheckoutPostMessageKind["TOKENIZE_ERROR"] = "TOKENIZE_ERROR";
    CheckoutPostMessageKind["CHECKOUT_READY"] = "CHECKOUT_READY";
    return CheckoutPostMessageKind;
}({});
class $9b7c8203005ff18b$export$4e94f40711c15818 extends Error {
    constructor(message, errors){
        super(message), this.name = "CheckoutConfigInputError";
        this.errors = errors;
    }
}
const $9b7c8203005ff18b$export$e65600b7ad68fd67 = [
    "Pay",
    "Submit"
];


// Descriptive SDK identity for the `x-highnote-sdk` adoption-telemetry header
// (`<name>/<version>`). Lives in @highnoteplatform/types because that is the
// only package bundled into every public SDK's parcel build (see
// secureChannel.ts) — the one bundle-safe shared home.
//
// HOW TO INSTRUMENT A NEW SDK
// 1. In the SDK package, import its own package.json name + version:
//        import { name, version } from "../package.json";
// 2. Build the identity so `name` can't drift from the published package name:
//        const SDK = sdkIdentityFromPackage({ name, version });
// 3. Page-context SDK: pass SDK as the 3rd arg to `highnoteClient(...)`, behind a
//    small `xxxClient` factory (see documentUploadClient / riskApplicationClient).
//    Iframe SDK: reuse SDK.name for BOTH the CDN path segment and the
//    secure-channel handshake `sdkName` (see card-viewer/secure-inputs
//    config.ts + handshake.ts) so telemetry and CDN can't desync.
const $2a4d223cccc63a35$var$SCOPE_PREFIX = /^@highnoteplatform\//;
const $2a4d223cccc63a35$export$3ddec0068072ba94 = (pkg)=>({
        name: pkg.name.replace($2a4d223cccc63a35$var$SCOPE_PREFIX, ""),
        version: pkg.version
    });


const $4b619e425ee14c6b$export$8acf5617026d4b16 = [
    "borderRadius",
    "backgroundColor",
    "color",
    "cursor",
    "fontFamily",
    "fontSize",
    "fontWeight",
    "letterSpacing",
    "lineHeight",
    "userSelect",
    "border"
];
const $4b619e425ee14c6b$export$93b12edf1b0f1762 = [
    ":focus",
    ":hover",
    ":invalid",
    ":valid"
];
const $4b619e425ee14c6b$export$679b0194e2408a3e = [
    "live",
    "test"
];




var $908ec3289223d8d0$exports = {};
$908ec3289223d8d0$exports = JSON.parse("{\"name\":\"@highnoteplatform/card-viewer\",\"version\":\"1.5.1\",\"description\":\"Render a payment card in your UI.\",\"source\":\"src/index.ts\",\"access\":\"public\",\"main\":\"lib/index.js\",\"module\":\"lib/esm/module.js\",\"types\":\"lib/types.d.ts\",\"files\":[\"lib\",\"README.md\"],\"scripts\":{\"clean\":\"rimraf lib dist\",\"prebuild\":\"npm run clean\",\"build\":\"PARCEL_WORKER_BACKEND=process parcel build --detailed-report --no-scope-hoist --no-cache\",\"postbuild\":\"node ../../scripts/fix-node-env.js\",\"prepublishOnly\":\"npm run build\",\"test\":\"jest\",\"test:watch\":\"jest --watch\",\"prepack\":\"npm run build\",\"predev\":\"node ../../scripts/clean-build-output.js lib dist\",\"dev\":\"parcel watch --port 3002 --hmr-port 2002 --no-cache --dist-dir=lib\"},\"author\":\"packages@highnote.com\",\"license\":\"MIT\",\"homepage\":\"https://highnote.com\",\"devDependencies\":{\"@highnoteplatform/types\":\"*\",\"@types/jest\":\"^28.1.7\",\"@types/uuid\":\"^9.0.1\",\"@types/jsdom\":\"21.1.1\",\"@types/node\":\"^22.0.0\",\"eslint-plugin-jest\":\"27.2.1\",\"jest\":\"^28.1.3\",\"jest-environment-jsdom\":\"^29.5.0\",\"jsdom\":\"^21.1.1\",\"ts-jest\":\"^28.0.8\"},\"targets\":{\"main\":{\"includeNodeModules\":[\"@highnoteplatform/types\"],\"optimize\":true},\"module\":{\"includeNodeModules\":[\"@highnoteplatform/types\"],\"optimize\":true}},\"dependencies\":{\"uuid\":\"^11.0.0\"}}");


const { CARD_VIEWER_IFRAME_PORT: $1ac10beeb563fbae$var$CARD_VIEWER_IFRAME_PORT = 3003 } = process.env;
const $1ac10beeb563fbae$var$identity = (0, $2a4d223cccc63a35$export$3ddec0068072ba94)({
    name: $908ec3289223d8d0$exports.name,
    version: $908ec3289223d8d0$exports.version
});
const $1ac10beeb563fbae$export$9345d7360ffe0722 = $1ac10beeb563fbae$var$identity.name;
const $1ac10beeb563fbae$export$91546b032799aa40 = $1ac10beeb563fbae$var$identity.version;
const $1ac10beeb563fbae$export$f76cea9319723dd2 = process.env.NODE_ENV === "production" ? "https://cdn.highnote.com" : `http://localhost:${$1ac10beeb563fbae$var$CARD_VIEWER_IFRAME_PORT}`;
// NOTE: the production iframe bundle is fetched from a fixed CDN path segment
// ("card-viewer") that MUST match the deploy pipeline's hardcoded app name
// (publish-release.yml `matrix.app`) — keep it a literal, never derived, so a
// package.json rename can't point the fetch at an undeployed path. The version
// segment keys the bundle to THIS package's version: a release that changes
// card-viewer-iframes without bumping @highnoteplatform/card-viewer would
// overwrite an already-deployed bundle in place — always version them together.
// The telemetry sdkName (handshake.ts) IS derived from the package name via
// packageName; handshake.test.ts asserts sdkName === "card-viewer", which pins
// packageName to this same literal so the telemetry label and CDN segment
// cannot silently desync.
const $1ac10beeb563fbae$var$iframePath = (apiEnvironment)=>{
    let path = "";
    if (process.env.NODE_ENV === "production") path = `card-viewer/${$1ac10beeb563fbae$export$91546b032799aa40}/`;
    return apiEnvironment === "test" ? `${path}index_test.html` : `${path}index.html`;
};
const $1ac10beeb563fbae$export$1c3aefb711c3a4cc = ()=>(0, $3y2hQ$uuid.v4)();
const $1ac10beeb563fbae$export$f7872bdb68630f49 = (apiEnvironment)=>`${$1ac10beeb563fbae$export$f76cea9319723dd2}/${$1ac10beeb563fbae$var$iframePath(apiEnvironment)}`;


const $9557ea95ebb86496$export$28ca0294113407cf = (config)=>{
    const frame = document.createElement("iframe");
    const frameSource = new URL("maskedOnLoad" in config ? `${(0, $1ac10beeb563fbae$export$f7872bdb68630f49)(config.environment)}?field=cardNumber&environment=${config.environment}&styles=${encodeURIComponent(JSON.stringify(config.styles ?? {}))}&enableClipboard=${config.enableClipboard ? "true" : "false"}&maskedOnLoad=${config.maskedOnLoad ? "true" : "false"}` : `${(0, $1ac10beeb563fbae$export$f7872bdb68630f49)(config.environment)}?field=${config.field}&styles=${encodeURIComponent(JSON.stringify(config.styles ?? {}))}&enableClipboard=${config.enableClipboard ? "true" : "false"}`);
    frameSource.hash = config.uuid;
    frame.setAttribute("src", frameSource.toString());
    frame.setAttribute("allow", "clipboard-write");
    frame.style.setProperty("border", "none");
    return frame;
};





const $23262b01d74df79c$var$FAILURE_MESSAGES = {
    FRAME_UNREACHABLE: "Unable to reach the card viewer frame. Please try again or contact support.",
    HANDSHAKE_TIMEOUT: "Card viewer frame did not respond. Please try again or contact support."
};
const $23262b01d74df79c$export$42fea92575e45d5 = ({ frame: frame, uuid: uuid, clientToken: clientToken, paymentCardId: paymentCardId, onError: onError, onHandshakeAck: onHandshakeAck })=>(0, $88ddf2e75f4a6fe1$export$84683bda827d284f)({
        frame: frame,
        iframeOrigin: $1ac10beeb563fbae$export$f76cea9319723dd2,
        uuid: uuid,
        clientToken: clientToken,
        paymentCardId: paymentCardId,
        sdkName: (0, $1ac10beeb563fbae$export$9345d7360ffe0722),
        sdkVersion: (0, $1ac10beeb563fbae$export$91546b032799aa40),
        onHandshakeAck: onHandshakeAck,
        onFailure: (failure)=>{
            onError({
                name: "CardViewerHandshakeError",
                message: $23262b01d74df79c$var$FAILURE_MESSAGES[failure]
            });
        }
    });




const $ba06ccfd87910023$var$FALLBACK_ERROR_MESSAGE = "Something went wrong. Please try again or contact support.";
const $ba06ccfd87910023$export$221b191fcfaf22a = (uuid, onError, onCopyToClipboardSuccess, onReady)=>(event)=>{
        if (event.origin !== (0, $1ac10beeb563fbae$export$f76cea9319723dd2) || uuid !== event.data.uuid) return false;
        const { data: data } = event.data;
        switch(data.__typename){
            case (0, $5bebb6f528a969bd$export$bdb47a4f704771fb).INVALID_CREDENTIAL_ERROR:
                {
                    const error = {
                        name: "InvalidCredentialError",
                        context: data.context
                    };
                    onError(error);
                    break;
                }
            case (0, $5bebb6f528a969bd$export$bdb47a4f704771fb).CARD_VIEWER_INPUT_ERROR:
                {
                    const error = {
                        name: "CardViewerFieldsInputError",
                        message: data.message
                    };
                    onError(error);
                    break;
                }
            case (0, $5bebb6f528a969bd$export$bdb47a4f704771fb).PAYMENT_CARD_FETCH_ERROR:
                {
                    const error = {
                        name: "CardViewerRequestError",
                        context: data.context,
                        message: data.message
                    };
                    onError(error);
                    break;
                }
            case (0, $5bebb6f528a969bd$export$bdb47a4f704771fb).COPY_TO_CLIPBOARD_ERROR:
                {
                    const error = {
                        name: "CopyToClipboardError",
                        message: data.message,
                        field: data.field
                    };
                    onError(error);
                    break;
                }
            case (0, $5bebb6f528a969bd$export$bdb47a4f704771fb).COPY_TO_CLIPBOARD_SUCCESS:
                onCopyToClipboardSuccess?.({
                    field: data.field
                });
                break;
            case (0, $5bebb6f528a969bd$export$bdb47a4f704771fb).CARD_VIEWER_READY:
                onReady?.();
                break;
            default:
                onError({
                    message: $ba06ccfd87910023$var$FALLBACK_ERROR_MESSAGE
                });
        }
        return true;
    };


const $f6142358ef0cb385$var$unmount = async (fields)=>{
    Object.values(fields).forEach((field)=>{
        if (field) {
            // Tear down the handshake first so no pending timer can call onError
            // after the frames are gone.
            field.disposeSecureChannel?.();
            field.container.replaceChildren("");
        }
    });
};
const $f6142358ef0cb385$export$1b4461fdcf0903a6 = async ({ clientToken: clientToken, paymentCardId: paymentCardId, elements: elements, onError: onError, onCopyToClipboardSuccess: onCopyToClipboardSuccess, environment: environment = "test", enableClipboard: enableClipboard = true, maskedOnLoad: maskedOnLoad = true, onReady: onReady })=>{
    const uuid = (0, $1ac10beeb563fbae$export$1c3aefb711c3a4cc)();
    // Dedupe the parent timeout and the iframe's relayed configure-timeout at
    // their convergence on onError (see HandshakeGate). Only cardNumber runs a
    // channel, so the failure latch is driven by exactly one handshake. relayError
    // is hoisted only to avoid re-wrapping; the gate state is shared via closure.
    const gate = (0, $88ddf2e75f4a6fe1$export$d572882ed38b887b)();
    const relayError = gate.wrapRelay(onError);
    const fields = (0, $5bebb6f528a969bd$export$7d576a40358207c0).reduce((accum, field)=>{
        const container = document.querySelector(elements[field].selector) ?? document.body;
        const frame = field === "cardNumber" ? (0, $9557ea95ebb86496$export$28ca0294113407cf)({
            styles: elements[field].styles,
            environment: environment,
            enableClipboard: enableClipboard,
            uuid: uuid,
            maskedOnLoad: maskedOnLoad
        }) : (0, $9557ea95ebb86496$export$28ca0294113407cf)({
            field: field,
            styles: elements[field].styles,
            enableClipboard: enableClipboard,
            uuid: uuid,
            environment: environment
        });
        const disposeSecureChannel = field === "cardNumber" ? (0, $23262b01d74df79c$export$42fea92575e45d5)({
            frame: frame,
            uuid: uuid,
            clientToken: clientToken,
            paymentCardId: paymentCardId,
            onError: gate.wrapFailure(onError),
            onHandshakeAck: gate.ack
        }) : undefined;
        container.append(frame);
        return {
            ...accum,
            [field]: {
                container: container,
                frame: frame,
                disposeSecureChannel: disposeSecureChannel
            }
        };
    }, {
        cardNumber: undefined,
        cvv: undefined,
        expirationDate: undefined
    });
    window.removeEventListener("message", (0, $ba06ccfd87910023$export$221b191fcfaf22a)(uuid, relayError, onCopyToClipboardSuccess, onReady));
    window.addEventListener("message", (0, $ba06ccfd87910023$export$221b191fcfaf22a)(uuid, relayError, onCopyToClipboardSuccess, onReady));
    return {
        toggleCardNumberMask: ()=>{
            const targetWindow = fields.cardNumber?.frame.contentWindow;
            if (targetWindow === null || targetWindow === undefined) return {
                name: "CardViewerToggleMaskError",
                message: "Unable to toggle card number mask."
            };
            targetWindow.postMessage({
                __typename: (0, $5bebb6f528a969bd$export$bdb47a4f704771fb).TOGGLE_CARD_NUMBER_MASK
            }, (0, $1ac10beeb563fbae$export$f76cea9319723dd2));
            return undefined;
        },
        unmount: async ()=>{
            await $f6142358ef0cb385$var$unmount(fields);
        }
    };
};


//# sourceMappingURL=index.js.map
